import React from 'react'
import SmsLegalDocument from '../components/SmsLegalDocument'

export default function SmsTerms() {
  return <SmsLegalDocument document="terms" />
}
